// src/store/auth/types.ts
export const SHOW_LOGIN_MODAL = "auth/SHOW_LOGIN_MODAL";
export const HIDE_LOGIN_MODAL = "auth/HIDE_LOGIN_MODAL";
export const SHOW_REGISTER_MODAL = "auth/SHOW_REGISTER_MODAL";
export const HIDE_REGISTER_MODAL = "auth/HIDE_REGISTER_MODAL";

export const LOGIN_REQUEST = "auth/LOGIN_REQUEST";
export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "auth/LOGIN_FAILURE";
export const LOGOUT = "auth/LOGOUT";
